import React from 'react';
import './PetAnimations.css';

export default function SlimeSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#81C784';
  const coreColor = color ? adjustAlpha(color, 0.5) : 'rgba(129, 199, 132, 0.5)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-bounce ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Shadow */}
      <ellipse cx="60" cy="102" rx="28" ry="6" fill="#000" opacity="0.08" />
      {/* Body - blobby */}
      <path
        d="M28 68C28 48 40 30 60 30C80 30 92 48 92 68C92 82 82 92 60 92C38 92 28 82 28 68Z"
        fill={bodyColor}
        opacity="0.7"
      />
      {/* Inner core */}
      <path
        d="M36 66C36 52 44 38 60 38C76 38 84 52 84 66C84 76 76 84 60 84C44 84 36 76 36 66Z"
        fill={coreColor}
      />
      {/* Shine */}
      <ellipse cx="48" cy="48" rx="10" ry="8" fill="white" opacity="0.3" transform="rotate(-20 48 48)" />
      <ellipse cx="72" cy="54" rx="4" ry="3" fill="white" opacity="0.2" />
      {/* Eyes */}
      <circle cx="48" cy="58" r="5" fill="white" />
      <circle cx="72" cy="58" r="5" fill="white" />
      <circle cx="49.5" cy="59" r="3" fill="#2C2419" />
      <circle cx="73.5" cy="59" r="3" fill="#2C2419" />
      <circle cx="50.5" cy="57.5" r="1.2" fill="white" />
      <circle cx="74.5" cy="57.5" r="1.2" fill="white" />
      {/* Mouth */}
      <path d="M54 68C54 68 57 72 60 72C63 72 66 68 66 68" stroke="#2C2419" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      {/* Drip blobs */}
      <ellipse cx="36" cy="86" rx="5" ry="6" fill={bodyColor} opacity="0.5" />
      <ellipse cx="80" cy="88" rx="4" ry="5" fill={bodyColor} opacity="0.4" />
    </svg>
  );
}

function adjustAlpha(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
